import type { ProducersOverviewProps } from 'features/producers-overview/types'
import Layout from 'components/layout/Layout'
import ProducersOverview from 'features/producers-overview/ProducersOverview'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import { DEFAULT_NAMESPACES, PRODUCERS_NAMESPACES } from 'constants/i18n'
import { useTranslation } from 'next-i18next/pages'
import type { SeoProps } from 'components/seo/types'
import { producersLib } from 'lib'
import { getLowerCaseLanguage } from 'utils/language'

const ProducersOverviewPage = (props: ProducersOverviewProps) => {
  // i18n
  const { t } = useTranslation('producers')

  // Constants
  const seo: SeoProps = {
    description: t(($) => $.seo.description),
    title: t(($) => $.seo.title)
  }

  return (
    <Layout {...{ seo }}>
      <ProducersOverview {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const language = getLowerCaseLanguage(locale)
  const producers = await producersLib.getProducers({ language, params: { enabled: true } })

  return {
    props: {
      producers,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, ...PRODUCERS_NAMESPACES], i18nConfig))
    },
    revalidate: 600 // re-generate page when a request comes in, once every 10 minutes
  }
}

export default ProducersOverviewPage
